import {Injectable} from '@angular/core';

declare var $: any;

@Injectable()
export class NotificationService {

  constructor() {
  }

  smallBox(data, cb?) {
    $.smallBox(data, cb)
  }

  bigBox(data, cb?) {
    $.bigBox(data, cb)
  }

  smartMessageBox(data, cb?) {
    $.SmartMessageBox(data, cb)
  }
  
  errorMessage(message, timeout = 4000)
  {
    $.smallBox(
      {
        title: "Error",
        content: "<b>" + message + "</b>",
        color: "#ff5151",
        icon: "fa fa-times fadeInRight animated",
        timeout: timeout
    }, null)
  }

  successMessage(message, timeout = 4000)
  {
    $.smallBox({
      title: "Success",
      content: "<b>"+message+"</b>",
      color: "#739E73",
      icon: "fa fa-check fadeInRight animated",
      timeout: timeout
    });
  }
}
